module.exports = __webpack_public_path__ + "img/ar.acc679e1.svg";